// Props accepted by Vuetify 1.5.22 v-dialog, including the mixins it uses
// (toggleable, bootable, detachable, overlayable, returnable).
const DIALOG_PROP_DEFS = {
  value: {
    type: Boolean,
    default: false
  },
  disabled: Boolean,
  persistent: Boolean,
  fullscreen: Boolean,
  fullWidth: Boolean,
  noClickAnimation: Boolean,
  light: Boolean,
  dark: Boolean,
  hideOverlay: Boolean,
  lazy: Boolean,
  scrollable: Boolean,
  maxWidth: {
    type: [String, Number]
  },
  width: {
    type: [String, Number]
  },
  origin: String,
  transition: {
    type: [String, Boolean]
  },
  attach: null,
  contentClass: null,
  returnValue: null
}

const DIALOG_PROP_NAMES = Object.keys(DIALOG_PROP_DEFS)

function pickDialogProps (source) {
  const picked = {}
  const props = source || {}

  for (let i = 0; i < DIALOG_PROP_NAMES.length; i++) {
    const name = DIALOG_PROP_NAMES[i]
    if (props[name] !== undefined) {
      picked[name] = props[name]
    }
  }

  return picked
}

function hasNamedSlot (slots, scopedSlots, name) {
  if (scopedSlots && scopedSlots[name]) {
    return true
  }
  return !!(slots && slots[name])
}

function shouldShowDialogHeader (label, showClose, hasHeaderSlot) {
  return !!(label || showClose || hasHeaderSlot)
}

function mergeDialogContentClass (contentClass) {
  if (!contentClass || typeof contentClass !== 'string') {
    return 'st-dialog'
  }
  return ('st-dialog ' + contentClass).trim()
}

module.exports = {
  DIALOG_PROP_DEFS,
  DIALOG_PROP_NAMES,
  pickDialogProps,
  hasNamedSlot,
  shouldShowDialogHeader,
  mergeDialogContentClass
}
